module.exports = __webpack_public_path__ + "img/addToken.3a76e98a.svg";